import React, {useEffect, useState} from "react";
import "./TermsConditions.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import {getAssetPath} from "../../services/helpers";
import {useNavigate} from "react-router-dom";

import {getLocalStorageData, storeData} from "../../services/localStorageService";

const TermsConditions = () => {

    return (
        <>
            <main className="main_wrapper terms-page">
       <div className="inn-ban" style={{marginBottom:50}}>
            <div className="container">
                <div className="row">
                    <h1>Terms & Conditions</h1>
                </div>
            </div>
        </div>
        
        <div className="container">
        {/* Introduction */}
        <div className="terms-div" id="introduction">
          <h2 className="div-title">Terms & Conditions</h2>

          <p>
            Dear User,
          </p>

          <p>
            Welcome to Vikas Mandal Mulund website.
          </p>

          <p>
            Vikas Mandal Mulund, is a public charitable trust registered
            under Mumbai Public Trust Act, 1950 vide Registration No.
            BOM-E 4412, ESTD. 1970. We are also registered with Public
            Health Department, BMC Registration No: T Ward/Reg No 4
            dated 6th July 2016.
          </p>

          <p>
            Our registered address - 101, Jai Laxminarayan Society,
            Lokmanya Tilak Road, Mulund (East), Mumbai 400081.
          </p>

          <p>
            From the year 2015, Vikas Mandal, Mulund is providing users
            or members the facility of registering profile information
            online for prospective brides and grooms to facilitate lawful
            marriages between persons of Leva Patidar community.
          </p>

          <p>
            Anyone desirous of using the services offered will be required
            to register their information online and become a member of
            Vikas Mandal Mulund’s Vadhu Var Suchi for the next one year.
          </p>

          <p>
            All such members desiring to register and communicating with
            other members of the Vadhu Var Suchi for the next one year
            must carefully read the following terms and conditions of use
            and should follow the instructions as provided in the
            registration process.
          </p>

          <p>
            "User" or "Member" means any person who accesses or avails
            the site of the Mandal for the purpose of hosting, publishing,
            sharing, transacting, displaying or uploading information or
            views and includes other persons jointly participating in using
            the site of the Mandal.
          </p>

          <p>
            By using / registering as a member of
            www.vikasmandalmulund.com, the member / user accepts to abide
            by the terms and conditions (hereinafter referred to as
            "Agreement") set forth herein.
          </p>

          <p>
            This agreement sets forth the terms and conditions for the
            membership of Vikas Mandal’s Vadhu Var Suchi (hereinafter
            referred to as "Suchi") and may be subject to modifications /
            amendments by Vikas Mandal Mulund (hereinafter referred to as
            "Mandal") from time to time.
          </p>
        </div>

        {/* Eligibility Criteria */}
        <div className="terms-div" id="eligibility">
          <h2 className="div-title">
            Eligibility Criteria
          </h2>

          <p>
            www.vikasmandalmulund.com (hereinafter referred to as
            "website") is intended to provide a platform for facilitating
            lawful marriages between persons of Leva Patidar community,
            who are legally competent to enter into such matrimonial
            relation under the laws of the country by which they are
            governed.
          </p>

          <p>
            In order to become / register as a member of the Suchi, the
            member must have attained the marriageable age according to
            the laws of the country which are applicable to and which
            govern the member / user.
          </p>

          <p>
            By becoming a member and / or using this website, the member /
            user represents and warrants that he / she has the right,
            authority, capacity and is legally competent to enter into
            this Agreement.
          </p>

          <p>
            The member / user is not prohibited or prevented by any
            applicable law in force for the time being or any other order
            or decree or injunction from any court, tribunal or any such
            competent authority restraining the member / user from
            entering into this Agreement.
          </p>

          <p>
            Any membership / use of the services provided by this website
            is void where the same is expressly prohibited under law or
            any order of any competent authority.
          </p>

          <p>
            If at any point of time Mandal has a reason to believe that
            the registered user is ineligible to be a member or that the
            member has misrepresented or not disclosed any material
            information about his / her eligibility or is in breach of
            the terms and conditions of this Agreement, the Mandal
            reserves the right to terminate the membership and the right
            to use the services provided by Mandal through its website
            without assigning any reasons thereof and without any
            compensation in any form / shape or manner to such member.
          </p>

          <p>
            In case membership is discontinued for any reason, new profile
            creation by the same email id for a member shall not be
            allowed.
          </p>

          <p>
            In India, users below 18 years age are not authorized to use
            these matrimony services at the Website.
          </p>
        </div>

        {/* Mobile Application Terms */}
        <div className="terms-div" id="mobile-app-terms">
          <h2 className="div-title">
            Vikas Mandal Mulund Mobile Application Specific Terms
          </h2>

          <p>
            By downloading or using the App, these terms will
            automatically apply to you – you should make sure therefore
            that you read them carefully before using the app.
          </p>

          <p>
            You’re not allowed to copy, or modify the app, any part of
            the app, or our trademarks in any way.
          </p>

          <p>
            You’re not allowed to attempt to extract the source code of
            the app, and you also shouldn’t try to translate the app into
            other languages, or make derivative versions.
          </p>

          <p>
            The app itself, and all the trade marks, copyright, database
            rights and other intellectual property rights related to it,
            still belong to Vikas Mandal Mulund.
          </p>

          <p>
            Vikas Mandal Mulund is committed to ensuring that the app is
            as useful and efficient as possible.
          </p>

          <p>
            For that reason, we reserve the right to make changes to the
            app or to charge for its services, at any time and for any
            reason.
          </p>

          <p>
            We will never charge you for the app or its services without
            making it very clear to you exactly what you’re paying for.
          </p>

          <p>
            The VikasMandal app stores and processes personal data that
            you have provided to us, in order to provide our Service.
          </p>

          <p>
            It’s your responsibility to keep your phone and access to the
            App secure.
          </p>

          <p>
            We therefore recommend that you do not jailbreak or root your
            phone, which is the process of removing software restrictions
            and limitations imposed by the official operating system of
            your device.
          </p>

          <p>
            It could make your phone vulnerable to malware, viruses,
            malicious programs, compromise your phone’s security features
            and it could mean that the VikasMandal app won’t work
            properly or at all.
          </p>
        </div>

        {/* Third Party Services */}
        <div className="terms-div" id="third-party">
          <h2 className="div-title">
            Third Party Services
          </h2>

          <p>
            The App does use third party services that declare their own
            Terms and Conditions.
          </p>

          <p>
            The links to Terms and Conditions of third party service
            providers used by the app are as below:
          </p>

          <ul className="terms-list">
            <li>Google Play Services</li>
            <li>Google Analytics for Firebase</li>
            <li>Firebase Crashlytics</li>
          </ul>
        </div>

        {/* Terms of Use */}
        <div className="terms-div" id="terms-use">
          <h2 className="div-title">
            Terms of Use
          </h2>

          <p>
            The Mandal’s Suchi is intended for the personal use of the
            individual members / users of the website and not for any
            commercial use by any member / user.
          </p>

          <p>
            The Mandal reserves the right to monitor the activity &
            status of the account of each member and further block the
            account of a member based on such review in its sole
            discretion.
          </p>

          <p>
            Any member / user is not permitted to register his / her
            multiple profiles and the Mandal reserves the right to
            deactivate any or all multiple profiles of a single member
            without any compensation whatsoever.
          </p>

          <h5 className="mt-4">
            Any member / user of the website is not permitted to:
          </h5>

          <ul className="terms-list">
            <li>
              Engage in advertising or solicitation of products/services
              without written permission.
            </li>

            <li>
              Transmit chain letters or junk emails to other members.
            </li>

            <li>
              Harass, abuse or harm another person using Suchi
              information.
            </li>

            <li>
              Use member information for personal/commercial or illegal
              purposes.
            </li>

            <li>
              Send obscene or unwarranted communications.
            </li>

            <li>
              Post obscene or inappropriate content/material.
            </li>
          </ul>
        </div>
        {/* Termination */}
        <div className="terms-div" id="termination">
          <h2 className="div-title">
            Termination
          </h2>

          <p>
            The member may terminate his / her membership of the Suchi at any
            time by giving written notice to the Mandal.
          </p>

          <p>
            The Mandal reserves the right to terminate the membership of any
            member and/or suspend access to the website if the member breaches
            any of the terms and conditions of this Agreement.
          </p>

          <p>
            Upon termination of membership, the member shall not be entitled
            to any refund or compensation whatsoever.
          </p>

          <p>
            The Mandal reserves the right to remove any profile and deny access
            to any user without assigning any reason if it believes that the
            member has violated the provisions of this Agreement or any
            applicable law.
          </p>
        </div>

        {/* Proprietary Rights */}
        <div className="terms-div" id="ownership-rights">
          <h2 className="div-title">
            Proprietary / Ownership Rights
          </h2>

          <p>
            The website contains copyrighted material, trademarks and other
            proprietary information including but not limited to text,
            software, photographs, graphics, video, music and sound.
          </p>

          <p>
            The entire contents of the website are protected by copyright laws
            and other intellectual property laws.
          </p>

          <p>
            Vikas Mandal Mulund owns and retains all proprietary rights in the
            website and the services provided through the website.
          </p>

          <p>
            The website contains trademarks, logos, service marks and other
            proprietary materials belonging to Vikas Mandal Mulund and/or its
            licensors.
          </p>

          <p>
            Members are prohibited from copying, reproducing, modifying,
            distributing, transmitting, displaying, publishing, licensing,
            creating derivative works from, transferring or selling any
            information, software, products or services obtained from the
            website.
          </p>

          <p>
            Any unauthorized use of the website's content may violate
            copyright laws, trademark laws and other applicable laws and could
            result in legal action.
          </p>
        </div>

        {/* Rights in Respect of Content Posted */}
        <div className="terms-div" id="content-rights">
          <h2 className="div-title">
            Rights in Respect of Content Posted on the Website
          </h2>

          <p>
            The Mandal reserves the right, but has no obligation, to monitor
            the materials posted on the website.
          </p>

          <p>
            The Mandal reserves the right to remove any content that violates
            this Agreement or is otherwise objectionable in its sole
            discretion.
          </p>

          <p>
            By posting content on the website, the member grants the Mandal a
            non-exclusive, worldwide, royalty-free license to use, reproduce,
            modify, publish and distribute such content for the purpose of
            operating the website and providing services.
          </p>

          <p>
            Members shall not upload, post, transmit or otherwise make
            available any content that:
          </p>

          <ul className="terms-list">
            <li>
              Promotes racism, hatred or physical harm against any individual
              or group.
            </li>

            <li>
              Harasses or advocates harassment of another person.
            </li>

            <li>
              Involves transmission of junk mail, chain letters or unsolicited
              mass mailing.
            </li>

            <li>
              Promotes information that the member knows to be false,
              misleading or promotes illegal activities.
            </li>

            <li>
              Contains restricted or password-only access pages.
            </li>

            <li>
              Displays pornographic or sexually explicit material.
            </li>

            <li>
              Provides instructional information about illegal activities.
            </li>

            <li>
              Contains viruses, Trojan horses, worms or other harmful
              computer programs.
            </li>

            <li>
              Violates any patent, trademark, copyright or other proprietary
              rights of any person.
            </li>

            <li>
              Impersonates another person or entity.
            </li>

            <li>
              Creates a false identity for misleading others.
            </li>
          </ul>

          <p>
            The Mandal reserves the right to investigate and take appropriate
            legal action against anyone who violates this provision.
          </p>
        </div>

        {/* Copyright Policy */}
        <div className="terms-div" id="copyright-policy">
          <h2 className="div-title">
            Copyright Policy
          </h2>

          <p>
            The Mandal respects the intellectual property rights of others and
            expects members and users to do the same.
          </p>

          <p>
            If you believe that your copyrighted work has been copied and is
            accessible on the website in a way that constitutes copyright
            infringement, you may notify the Mandal by providing the following
            information:
          </p>

          <ul className="terms-list">
            <li>
              A physical or electronic signature of the copyright owner or
              authorized representative.
            </li>

            <li>
              Identification of the copyrighted work claimed to have been
              infringed.
            </li>

            <li>
              Identification of the material that is claimed to be infringing
              and information reasonably sufficient to locate the material.
            </li>

            <li>
              Contact details including address, telephone number and email
              address.
            </li>

            <li>
              A statement that the complaining party has a good faith belief
              that the use is not authorized by the copyright owner.
            </li>

            <li>
              A statement that the information in the notice is accurate and,
              under penalty of perjury, that the complaining party is
              authorized to act on behalf of the copyright owner.
            </li>
          </ul>

          <p>
            Upon receipt of a valid copyright infringement notice, the Mandal
            may remove or disable access to the allegedly infringing material.
          </p>
        </div>

          {/* Member Disputes */}
          <div className="terms-div" id="member-disputes">
            <h2 className="div-title">
              Member Disputes
            </h2>

            <p>
              The member is solely responsible for his or her interactions with
              other members and users of the website.
            </p>

            <p>
              The Mandal reserves the right, but has no obligation, to monitor
              disputes between members.
            </p>

            <p>
              The Mandal shall not be responsible or liable for any disputes,
              disagreements, claims, damages or losses arising out of or in
              connection with interactions between members.
            </p>

            <p>
              Members are advised to exercise due caution and independent
              judgment before entering into any relationship or arrangement with
              another member.
            </p>
          </div>
          {/* Disclaimers */}
          <div className="terms-div" id="disclaimers">
            <h2 className="div-title">
              Disclaimers
            </h2>

            <p>
              The information provided in the Suchi is on an "as is" and
              "as available" basis and therefore the Mandal makes no
              representations or warranties of any sort whether express
              or implied as to the operation or any information, content,
              materials or products included on this site.
            </p>

            <p>
              The member expressly agrees that the member is accessing
              this website at his / her own sole risk and shall not hold
              the Mandal liable / responsible for any damage caused to
              him / her by use of the website.
            </p>

            <p>
              The Mandal does not warrant that the site or the server or
              any e-mail sent by the Mandal is free of viruses, worms,
              Trojans or any other harmful programs.
            </p>

            <p>
              The Mandal or its licensees shall not be liable for any
              damages including but not limited to direct, indirect,
              incidental, punitive and consequential damages of any kind
              arising from the use of the website or services.
            </p>

            <p>
              The Mandal will not be liable for any kind of inaccurate
              information or content posted on the website in connection
              with the Mandal’s service whether such inaccurate
              information is posted by members/users or due to any
              malfunction of its servers, computers, equipment or
              mechanisms associated with utilization of the services.
            </p>

            <p>
              The Mandal absolves itself from liabilities caused due to
              technical malfunctions including telephone lines, LAN,
              network systems, software failures, internet congestion,
              service provider issues or email delivery failures.
            </p>

            <p>
              The member shall in no way hold the Mandal liable for any
              loss or damage arising out of or subsequent to any
              relationship established through the use of the services.
            </p>

            <p>
              The Mandal disclaims any liability arising from any content
              posted on the website by members, users or third parties.
            </p>

            <p>
              The Mandal shall not be responsible or liable for any
              illegal content posted on the website by any member, user
              or third party.
            </p>
          </div>

          {/* Limitation on Liability */}
          <div className="terms-div" id="limitation-liability">
            <h2 className="div-title">
              Limitation on Liability
            </h2>

            <p>
              In no event shall Vikas Mandal be liable for the acts of
              third parties or for any kind of damages whether direct or
              indirect including loss of profits arising from the use of
              the Mandal’s website, services provided on the website or
              the Suchi.
            </p>
          </div>

          {/* Governing Law */}
          <div className="terms-div" id="governing-law">
            <h2 className="div-title">
              Governing Law and Jurisdiction
            </h2>

            <p>
              All matters arising out of or relating to this Agreement
              including any dispute arising under this Agreement between
              any member/user and the Mandal and/or involving the website
              www.vikasmandalmulund.com shall be governed by the laws of
              India.
            </p>

            <p>
              Such matters shall be subject to the exclusive jurisdiction
              of the competent courts of Mumbai.
            </p>
          </div>

          {/* Indemnity */}
          <div className="terms-div" id="indemnity">
            <h2 className="div-title">
              Indemnity
            </h2>

            <p>
              The member/user agrees to indemnify and hold Vikas Mandal,
              Mulund, its affiliates, subsidiaries, agents, officers,
              employees and other partners harmless from any liability,
              loss, demand or claim made by any other member, user or
              third party.
            </p>

            <p>
              This includes claims arising from the use of the website
              www.vikasmandalmulund.com or the services provided by the
              Mandal, including reasonable attorney's fees.
            </p>

            <p>
              The indemnity shall also apply to violations of this
              Agreement, breaches of member/user representations and
              warranties or any fraudulent act on the part of the
              member/user.
            </p>
          </div>

          {/* General */}
          <div className="terms-div" id="general">
            <h2 className="div-title">
              General
            </h2>

            <p>
              By becoming a member of the Mandal’s website and thereby
              agreeing to list candidate information in the Suchi, the
              member agrees to receive emails and/or SMS communications
              from Vikas Mandal, Mulund.
            </p>

            <p>
              The member may manage subscription to such emails by
              sending an email or giving express written notice to the
              Mandal.
            </p>

            <p>
              The member confirms that as on the date of registration,
              the member is not on the DND (Do Not Disturb) subscribers
              list with any telecom operator or authority.
            </p>

            <p>
              In the event that the member is a DND subscriber, the
              member agrees not to object to any message sent by Vikas
              Mandal, Mulund or its affiliates.
            </p>

            <p>
              The user/member grants permission to the Mandal for
              contacting the user/member through electronic or physical
              media for information regarding programs and projects of
              the Mandal.
            </p>

            <p>
              Each provision of this Agreement shall be considered
              severable. If any provision is held invalid or
              unenforceable under Indian law, such invalidity shall not
              affect the remaining provisions of this Agreement.
            </p>

            <p>
              The invalid provision shall be amended in a reasonable
              manner to achieve the intention of this Agreement and if
              not possible shall be severed while the remaining
              provisions remain in full force and effect.
            </p>

            <p>
              The provisions of this Agreement can be amended from time
              to time by Vikas Mandal, Mulund.
            </p>

            <p>
              This Agreement shall be deemed accepted upon completion and
              use of the registration process for membership of this
              website and all members shall be deemed to have read,
              understood and accepted these terms and conditions before
              registering.
            </p>
          </div>

          {/* Changes to Terms */}
          <div className="terms-div" id="changes-terms">
            <h2 className="div-title">
              Changes to This Terms and Conditions
            </h2>

            <p>
              We may update our Terms and Conditions from time to time.
              Therefore, you are advised to review this page periodically
              for any changes.
            </p>

            <p>
              We will notify you of any changes by posting the updated
              Terms and Conditions on this page.
            </p>

            <p>
              These Terms and Conditions are effective as of
              1st July 2023.
            </p>
          </div>

          {/* Contact Us */}
          <div className="terms-div" id="contact-us">
            <h2 className="div-title">
              Contact Us
            </h2>

            <p>
              If you have any questions or suggestions about our Terms
              and Conditions, do not hesitate to contact us at:
            </p>

            <p>
              <strong>support@vikasmandalmulund.com</strong>
            </p>
          </div>

          {/* Agreement Checkbox */}
          {/*<div className="terms-agreement">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="agreeTerms"
              />

              <label
                className="form-check-label"
                htmlFor="agreeTerms"
              >
                I have read and agree to the Terms of Use &
                Privacy Policy
              </label>
            </div>
          </div>*/}
          </div>
      </main>
        </>
    );
};

export default TermsConditions;
